import axiosPublicClient from "../../../../axiosPublicClient"

const service = async (data) => {
    const result = await axiosPublicClient.post(`/submit-pre-check-form`, data)

    return result.data
}

export default service
